const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManSettled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 11508",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 124,
    viewBox: "0 0 200 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eqhui6snva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7414",
    style: {
      fill: "none"
    },
    d: "M0 0h200v124H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7mzcv7rzkb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7411",
    transform: "translate(144.965 94.974)",
    style: {
      fill: "none"
    },
    d: "M0 0h11.317v14.899H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xek5yf9a6c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7412",
    transform: "translate(41.75 106.457)",
    style: {
      fill: "none"
    },
    d: "M0 0h5.079v5.539H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11507",
    style: {
      clipPath: "url(#eqhui6snva)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7407",
    style: {
      fill: "#fff"
    },
    d: "M0 0h200v124H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7408",
    transform: "translate(40.404 117.697)",
    style: {
      fill: "#d3d7df"
    },
    d: "M0 0h115.1v.8H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11506"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11505",
    style: {
      clipPath: "url(#eqhui6snva)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28177",
    d: "M44.4 118.1a335.35 335.35 0 0 1-4.8-57.3C39.7 29.6 52.1 10 65.1 5.1 91-4.6 100.8 12.3 111 29.2c2.5 4.1 10.2 16.7 23.2 19.5 8.7 1.9 14.5-1.7 20.4 2.6 1.6 1.2 5.1 4.3 6.6 14.1 3.1 20.2-7.4 43.5-12.4 52.7z",
    style: {
      fill: "#edeff8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28178",
    d: "M101.2 7c-.5 1.7 3.9 2.7 8.9 9.1 5.1 6.4 3.7 9 8 15.5 1.6 2.4 7.2 10.8 17.4 13.4 1.3.3 12.8 3.2 16.5-1.9 4.7-6.4-4.1-24.3-17.9-32.8-13.9-8.6-32-6.7-32.9-3.3",
    style: {
      fill: "#edeff8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28179",
    d: "M53.2 71.5 75 57l21.3 31.9-21.7 14.6z",
    style: {
      fill: "#b7becc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28180",
    d: "m85.1 87.4-.3 1.5-10.7-1.5.2-1.6z",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28181",
    d: "m79.6 82 1.6.3-1.8 10.5-1.5-.2z",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28182",
    d: "M69.7 68.5s-2.2 1.5-4.9 3.3-4.9 3.3-4.9 3.2c0 0 2.2-1.5 4.9-3.3s4.9-3.2 4.9-3.2",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28183",
    d: "M77.6 66.5S74 69 69.5 72s-8.2 5.4-8.2 5.4 3.6-2.5 8.1-5.5c4.7-3 8.2-5.5 8.2-5.4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28184",
    d: "M79.2 68.9s-3.6 2.5-8.1 5.5-8.2 5.4-8.2 5.4 3.6-2.5 8.1-5.5c4.7-3 8.2-5.5 8.2-5.4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28185",
    d: "M80.9 71.3s-3.6 2.5-8.1 5.5-8.2 5.4-8.2 5.4 3.6-2.5 8.1-5.5 8.1-5.5 8.2-5.4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28186",
    d: "M82.5 73.7s-3.6 2.5-8.1 5.5-8.2 5.4-8.2 5.4 3.6-2.5 8.1-5.5 8.1-5.4 8.2-5.4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7409",
    transform: "rotate(-33.779 213.854 -167.57)",
    style: {
      fill: "#b7becc"
    },
    d: "M0 0h21.9v32.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28187",
    d: "M143.2 88s-1.8 1.3-4.1 2.8-4.1 2.7-4.1 2.7 1.8-1.3 4.1-2.8c2.2-1.5 4-2.7 4.1-2.7",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28188",
    d: "M149.8 86.4s-3 2.1-6.8 4.6-6.9 4.6-6.9 4.5c0 0 3-2.1 6.8-4.6s6.9-4.6 6.9-4.5",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28189",
    d: "M151.1 88.4s-3 2.1-6.8 4.6-6.9 4.6-6.9 4.5c0 0 3-2.1 6.8-4.6 3.9-2.5 6.9-4.6 6.9-4.5",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28190",
    d: "M152.5 90.4s-3 2.1-6.8 4.6-6.9 4.6-6.9 4.5c0 0 3-2.1 6.8-4.6s6.9-4.5 6.9-4.5",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28191",
    d: "M153.8 92.4s-3 2.1-6.8 4.6-6.9 4.6-6.9 4.5c0 0 3-2.1 6.8-4.6 3.9-2.5 6.9-4.5 6.9-4.5",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7410",
    transform: "rotate(-61.862 105.613 -30.885)",
    style: {
      fill: "#b7becc"
    },
    d: "M0 0h33.3v22.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28192",
    d: "M107.8 58.9s-2-1-4.5-2.4a44.838 44.838 0 0 1-4.5-2.5s2 1 4.5 2.4 4.5 2.5 4.5 2.5",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28193",
    d: "M112.6 64.1s-3.4-1.7-7.5-3.9-7.4-4-7.4-4 3.4 1.7 7.5 3.9c4 2.2 7.4 4 7.4 4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28194",
    d: "M111.4 66.3s-3.4-1.7-7.5-3.9-7.4-4-7.4-4 3.4 1.7 7.5 3.9 7.4 4 7.4 4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28195",
    d: "M110.2 68.5s-3.4-1.7-7.5-3.9-7.4-4-7.4-4 3.4 1.7 7.5 3.9 7.4 4 7.4 4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28196",
    d: "M109 70.7s-3.4-1.7-7.5-3.9-7.4-4-7.4-4 3.4 1.7 7.5 3.9 7.4 4 7.4 4",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28197",
    d: "M100.9 78.1 94 113.2l-.9 4.6 45.7-.2c2.1 0 3.9-1.8 4.5-4.6l8.1-33.2c.5-2.1-.6-4.2-2.2-4.2H103a2.808 2.808 0 0 0-2.1 2.5",
    style: {
      fill: "#34395f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28198",
    d: "m134.5 110.8-4.9-38.9a3.115 3.115 0 0 0-3-2.8H116a2.878 2.878 0 0 0-2.1.9l-5.1 5.4-29.5.2a3.174 3.174 0 0 0-3 3.6l4.5 36a3.114 3.114 0 0 0 3 2.8l51.4-.1c5.7.1 6.3-1.6 6.3-1.6-6.4 1.5-7-5.5-7-5.5",
    style: {
      fill: "#5843be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28199",
    d: "M119.6 81.834a3.63 3.63 0 0 0-2.6 1.1c-5.9 5.9-10.4 10.8-15.6 16.2l-5.5-4.6a3.754 3.754 0 1 0-5 5.6c.1.1.1.1.2.1l8.1 6.9a3.72 3.72 0 0 0 5.1-.2c6.7-6.8 11.5-12.1 18-18.7a3.775 3.775 0 0 0 .1-5.3 3.555 3.555 0 0 0-2.8-1.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11501",
    style: {
      opacity: 0.66
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11500"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11499",
    style: {
      clipPath: "url(#7mzcv7rzkb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28200",
    d: "M153.6 95.234a1.594 1.594 0 0 0-.8 1c-1 3.6-1.7 6.6-2.6 10l-3.2-.6a1.687 1.687 0 0 0-.7 3.3h.1l4.8.9a1.774 1.774 0 0 0 2-1.2c1.2-4.2 1.9-7.4 3-11.5a1.665 1.665 0 0 0-1.2-2.1 1.7 1.7 0 0 0-1.4.2",
    style: {
      fill: "#ebe7ff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28201",
    d: "M35.5 99.4a3.792 3.792 0 0 1 2.7 1.4 7.388 7.388 0 0 1 1.4 2.8 11.99 11.99 0 0 1-.4 6.2c-2.1-.8-3.4-3-4-4.2-.9-1.9-1.5-5.9.3-6.2",
    style: {
      fill: "#5843be"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11504",
    style: {
      opacity: 0.88
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11502",
    style: {
      clipPath: "url(#xek5yf9a6c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28202",
    d: "M42.3 112a3.266 3.266 0 0 1-.2-3.3 4.213 4.213 0 0 1 2.6-2.1 1.81 1.81 0 0 1 1.6.1 1.3 1.3 0 0 1 .5 1.3 3.506 3.506 0 0 1-.6 1.4 5.862 5.862 0 0 1-3.9 2.6",
    style: {
      fill: "#5843be"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28203",
    d: "M42.5 118.5a1.577 1.577 0 0 0-.1-.4c-.1-.3-.1-.7-.2-1.1a10.714 10.714 0 0 1-.2-3.7 7.548 7.548 0 0 1 1.4-3.5 5.929 5.929 0 0 1 .8-.8c.1-.1.2-.1.3-.2a.1.1 0 0 0 .1-.1 4.447 4.447 0 0 0-1.1 1.1 7.123 7.123 0 0 0-1.3 3.4 10.714 10.714 0 0 0 .2 3.7 7.471 7.471 0 0 0 .2 1.1 1.75 1.75 0 0 0-.1.5",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28204",
    d: "M36.2 102.3a.31.31 0 0 0 .1.2c.1.1.1.3.2.5.2.4.4 1 .8 1.7.6 1.5 1.5 3.5 2.4 5.8s1.6 4.4 2.2 5.9a18.4 18.4 0 0 1 .6 1.8c.1.2.1.4.2.5v.2a.311.311 0 0 0-.1-.2 1.7 1.7 0 0 0-.2-.5c-.2-.4-.4-1-.7-1.8-.6-1.5-1.3-3.6-2.2-5.9s-1.7-4.3-2.3-5.8c-.3-.7-.5-1.3-.7-1.8-.1-.2-.1-.4-.3-.6",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28205",
    d: "M40 114.2a7.539 7.539 0 0 0-6-3.7c-.6 0-1.4.1-1.7.6-.3.6.1 1.2.5 1.7a6.679 6.679 0 0 0 7.2 1.6",
    style: {
      fill: "#5843be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28206",
    d: "M34.9 112.1h.4a1.089 1.089 0 0 1 .5.1c.2 0 .4.1.6.1.2.1.5.1.7.2.3.1.5.2.8.3a10.675 10.675 0 0 1 1.7 1 9.214 9.214 0 0 1 1.4 1.4 3.039 3.039 0 0 1 .5.7c.1.2.3.4.4.6a1.423 1.423 0 0 1 .2.6c.1.2.1.3.2.4a1 1 0 0 1 .1.4s-.2-.5-.6-1.3a2.1 2.1 0 0 0-.4-.6c-.1-.2-.3-.4-.5-.7a5.826 5.826 0 0 0-1.4-1.3 14 14 0 0 0-1.6-1c-.3-.1-.5-.2-.8-.3a1.859 1.859 0 0 0-.7-.2 10.973 10.973 0 0 0-1.5-.4",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28207",
    d: "m66.3 122.5-.2.2.6.9a28.606 28.606 0 0 0 3.3-.4 5.554 5.554 0 0 0 1.8-1.3 7.444 7.444 0 0 0 0-1.5z",
    style: {
      fill: "#3a4a80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28208",
    d: "M67.1 116.4a24.345 24.345 0 0 0-.6 3.1c-.1.7-.2 2.3-.2 2.3l-.1.7s2.7 0 3.3-.1 2.2-1.7 2.2-1.7v-5.1z",
    style: {
      fill: "#1c2341"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28209",
    d: "m50.6 118.6-.5.1-.3.7a8.76 8.76 0 0 0 2 .8 15.029 15.029 0 0 0 3 0 6.482 6.482 0 0 0 2.4-.9c.7-.5 2.4-1.7 2.4-1.7v.7a3.242 3.242 0 0 0 1.3-.1c.5-.2 1.6-.7 1.6-.7l-.3-1.4-4.6-.4z",
    style: {
      fill: "#3a4a80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28210",
    d: "M57 114.1a27.411 27.411 0 0 1-3.9 3.1 8.506 8.506 0 0 1-2.5.6s-.5.1-.5.5v.5a4.036 4.036 0 0 0 2.4 1.1c1.1-.1 3.7-.3 4.7-1.1a17.124 17.124 0 0 1 3.3-2.2c.9-.2 1.9-.5 1.9-.5l-.3-1.7z",
    style: {
      fill: "#1c2341"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28211",
    d: "m52.2 54-7.1-7a2.445 2.445 0 0 1-.2-1.7 3.539 3.539 0 0 0 .3-1.9c-.1-.4-.5-2-.5-2.3s-.5-.1-.5.3a5.709 5.709 0 0 0 0 1.3 4.4 4.4 0 0 1 .1.9s-.6.2-.8-.1-2.2-3.7-2.2-3.7-.7-.3-.6 0l.1.3-.4-.6s-.6-.1-.5.2l.1.3a4.286 4.286 0 0 0-.5-.1.528.528 0 0 0-.1.7l.2.4s-.6 0-.4.5 1 1.9 1 1.9a12.8 12.8 0 0 0 .5 1.7 6.221 6.221 0 0 0 1.2 2l.6.6s7.2 9.4 7.4 9.7a2.5 2.5 0 0 0 2 .7l.9-.2z",
    style: {
      fill: "#b8b8f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28212",
    d: "M57.1 69.2s-1 11.5-1.2 14.6c-.1 3.1 1.3 14.7 1.2 17.1-.2 2.4-.3 9.6-.3 10.1a6.117 6.117 0 0 0 .3 1.4l-1.3 2a3.781 3.781 0 0 0 2.3 1.2 27.062 27.062 0 0 0 4.4-1.2.555.555 0 0 1-.3-.6 3.18 3.18 0 0 0 .3-1.4 7.562 7.562 0 0 0-1-1.7s2.3-11.3 2.3-12.9.6-10.1.6-10.1l-1-19.8z",
    style: {
      fill: "#28226c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28213",
    d: "m64.5 87.7-.8-15.1a11.812 11.812 0 0 0-3-4.1l-1 .2c-1.5 2-.6 12.2-.1 16.3.6 4.8 1.1 5.6 1.9 12.3.7 5.3.8 8.2.9 9.5.7-3.4 1.5-8 1.5-8.9-.1-1.7.6-10.2.6-10.2",
    style: {
      fill: "#1c1752"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28214",
    d: "M57.2 47.4a42.353 42.353 0 0 1-3.3 4.8 16.83 16.83 0 0 1-2.2 1.5v5s3.6-.5 4.1-.9 1.9-4.2 1.9-4.2z",
    style: {
      fill: "#463aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28215",
    d: "M58.5 70.2s3.1 10.7 3.9 12.3a92.543 92.543 0 0 1 3.8 13.8c.2 2.2 1.1 9.4 1.1 11.1v5.8a1.108 1.108 0 0 1-.5.9 5.8 5.8 0 0 0-.1 2.4l.3.6 4.3.2a8.527 8.527 0 0 0 1-3c-.1-.9-.2-3.7-.2-3.7s-.2-16.5-.4-18.2c0-1.6-.6-9.9-.9-11.5-.3-1.5-1.8-15.3-1.8-15.3z",
    style: {
      fill: "#28226c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28216",
    d: "M57.6 47.1a20.232 20.232 0 0 0 2.1-.8c.2-.1.5-.2 1.3-.5a8.624 8.624 0 0 1 1.6-.6c2.2-.8 3.3-1.3 4.4-1.1 1.4.3 1.2 1.5 3.1 2.7 2.1 1.3 4 .8 4.2 1.6.2.7-1.5 1.2-2.7 2.7-1.3 1.6-1.3 3.5-1 7.3.6 9 1.3 10.8 0 11.9-1 .9-1.9.1-6.2.3-5.8.2-7 1.7-8.4.7-2.3-1.7.7-5.5.2-15.2-.1-1.7-.5-8.2 1.4-9",
    style: {
      fill: "#5943bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28217",
    d: "m61.1 52.6 6.5-8.2a4.925 4.925 0 0 0-.7-.3h-.3l-2.2.4c-.5.2-1.1.4-1.8.7-.4.1-.7.3-1.6.6a3.4 3.4 0 0 0-.8.3z",
    style: {
      fill: "#7f75e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28218",
    d: "M60.7 42.6s.6 4.3.6 4.6.2 3.9.2 3.9l5.1-7.1-.5-4.2z",
    style: {
      fill: "#bab8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28219",
    d: "M60.6 32.1c-.6-.1-1.6 1.4-2 2.5-.7 1.9-.4 4.3.3 4.5.6.2 1.5-1.4 1.6-1.6 1.3-2.2.9-5.2.1-5.4",
    style: {
      fill: "#5943bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28220",
    d: "M65.6 33.1c.6-.1 1.4.6 1.7 1.3a2.573 2.573 0 0 1 .1 1.5c-.1 1.6-.2 2.4-.7 2.8a1.956 1.956 0 0 1-2.2-.1c-1.5-1.2-.2-5.3 1.1-5.5",
    style: {
      fill: "#5943bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28221",
    d: "M60.2 33.7a4.891 4.891 0 0 0-.7 2.5c-.3 2.3-.5 3.4 0 4.8.2.7 1 3.1 3 3.4a3.754 3.754 0 0 0 3.2-1.6c.5-.7.6-1.9.8-4.4.2-2.1.1-2.6-.1-3a3.839 3.839 0 0 0-1.9-2.2c-1.5-.7-3.4-.6-4.3.5",
    style: {
      fill: "#9b9bd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28222",
    d: "M65.6 42.9a3.522 3.522 0 0 0 .5-1.8 3.666 3.666 0 0 1-2.5 1.9c-.5.1-1.4-.3-1.5-.8a7.449 7.449 0 0 1 .2-1.8 3.519 3.519 0 0 1-1.2-.2c-.3-.3 0-.3.3-.7a4.909 4.909 0 0 0 .6-2.7c-.1-.7-1.4-1.8-2.3-2.4-.1.4-.2.9-.4 1.8-.3 2.3-.5 3.4 0 4.8.2.7 1 3.1 3 3.4a3.869 3.869 0 0 0 3.3-1.5",
    style: {
      fill: "#bab8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28223",
    d: "M59.7 38.5c-.3-.4-.8-.8-1.1-.6-.4.2-.5 1.3 0 1.9.3.4.9.7 1.2.5.4-.2.4-1.2-.1-1.8",
    style: {
      fill: "#bab8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28224",
    d: "M66 38.5c.1-.1.6-.9 1.2-.7.3.1.4.3.5.3a2.008 2.008 0 0 1-.7 2.4c-.1 0-.7.5-1.1.2-.6-.3-.4-1.5.1-2.2",
    style: {
      fill: "#9b9bd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28225",
    d: "M58.8 31.7c-.3.8 1.3 1.9 1.6 2.2a6.242 6.242 0 0 0 4.1 1.2c.4 0 2.1-.2 2.3-1 .2-.9-1.8-2-2-2.1-2.4-1.3-5.7-1.3-6-.3",
    style: {
      fill: "#5943bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28226",
    d: "M58.7 56.6c.1 0 .1.2.2.3.7 1.8 2.7 3.2 3.6 3.8 2.8 1.8 5.3 1.3 5.3 1.8 0 .8-6.5 3.6-9 .5-1.8-2.3-.5-6.4-.1-6.4",
    style: {
      fill: "#463aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28227",
    d: "M66.6 71.8a3.649 3.649 0 0 0 1.2 1.7c.7.5 7.6-5.2 8-5.6s-.4-10.1-.4-10.1l-4.3.2.2 7.3a1.75 1.75 0 0 1-.4 1.2z",
    style: {
      fill: "#b8b8f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28228",
    d: "M74.3 48.4a5.561 5.561 0 0 1 1.9 3.4c.1 1.9-.3 3.5 0 5.2a15.712 15.712 0 0 0 .6 2.5h-6.2s-.6-5.8-.6-6.8 1.6-3.6 2.4-3.9a4.7 4.7 0 0 1 1.9-.4",
    style: {
      fill: "#463aad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28229",
    d: "M43 44a1.461 1.461 0 0 0 .1 1.1l.3.4-1.7-.4z",
    style: {
      fill: "#bfbde4"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManSettled);
export default __webpack_public_path__ + "static/media/man-settled.ce6d7c3f9601ac57c06e190dec18e941.svg";
export { ForwardRef as ReactComponent };